import type { FindingClass } from '@/lib/conversationReviews.ts';

/* Grouped by the severity each class carries, worst first, so the filter menu reads as the scale. */
export const FINDING_CLASS_ORDER: FindingClass[] = [
  'said_it_did_not_help',
  'gave_up',
  'asked_for_a_human',
  'corrected_wundo',
  'repeated_request',
  'wundo_could_not_help',
  'unsupported_request',
];

export const FINDING_CLASS_LABELS: Record<FindingClass, string> = {
  said_it_did_not_help: 'Said it did not help',
  gave_up: 'Gave up',
  asked_for_a_human: 'Asked for a human',
  corrected_wundo: 'Corrected Wundo',
  repeated_request: 'Repeated request',
  wundo_could_not_help: 'Wundo could not help',
  unsupported_request: 'Unsupported request',
};

/* Findings stored before the reviewer asked about the user's reaction carry classes no longer listed. */
export function findingClassLabel(findingClass: string): string {
  return (FINDING_CLASS_LABELS as Record<string, string>)[findingClass] ?? findingClass;
}

/* Where the severity changes, so the menu can draw a hairline between the rungs. */
export const FINDING_CLASS_GROUP_STARTS: ReadonlySet<FindingClass> = new Set([
  'corrected_wundo',
  'unsupported_request',
]);
